import { render, staticRenderFns } from "./OrganisationInvoices.vue?vue&type=template&id=31188e20&"
import script from "./OrganisationInvoices.vue?vue&type=script&lang=js&"
export * from "./OrganisationInvoices.vue?vue&type=script&lang=js&"
import style0 from "./OrganisationInvoices.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports